import { Dispatch } from '@ngxs-labs/dispatch-decorator';

export class Dispatchable {
  @Dispatch()
  static dispatch<T extends new (...args: any) => any>(this: T, ...args: ConstructorParameters<T>) {
    return new this(...(args as any));
  }
}
